// extracted by mini-css-extract-plugin
export var alaskaBlocks = "logo-module--alaskaBlocks--lDAkE";
export var logo_svg = "logo-module--logo_svg--N+sTy";
export var mtaLetters = "logo-module--mtaLetters--uzqYn";